import { AsyncState, loadingAsyncState, unloadedAsyncState } from "widgets-for-react"
import { fetchFilterOptions, GroupedOverviewResult } from "../../../backendApi/EventsApi"
import { GroupedOverviewFilterOptions, GroupedOverviewParams } from "../../../backendApi/generated"
import { emptyFragment } from "../../../utils/react"
import { JumboComponent, JumboProps } from "../../Jumbo/Jumbo"

export type FilterSettings = GroupedOverviewParams

export const emptyFilters: FilterSettings = {
  page: 1,
  from: new Date(),
  tags: [],
  regions: [],
  locations: [],
  query: ''
};

export type FilterUpdaters = {
  [K in keyof Required<FilterSettings> as `update${Capitalize<string & K>}`]: (value: FilterSettings[K]) => void
} & {
  toggleFilterVisibility: () => void
  updateFrom: (from: Date) => void
  resetFilter: () => void
}

export interface EventOverviewState {
  filterOptions: AsyncState<GroupedOverviewFilterOptions>
  filterSettings: FilterSettings
  filterExpanded: boolean
  events: AsyncState<GroupedOverviewResult>
  jumboContent: AsyncState<JumboProps>
  Jumbo: JumboComponent
}

export const emptyFilterOptions: Required<GroupedOverviewFilterOptions> = {
  tags: [],
  regions: [],
  locations: []
}

export const initialEventOverviewState: EventOverviewState = {
  filterOptions: loadingAsyncState<GroupedOverviewFilterOptions>(fetchFilterOptions, emptyFilterOptions),
  filterSettings: emptyFilters,
  filterExpanded: false,
  events: unloadedAsyncState<GroupedOverviewResult>(),
  jumboContent: unloadedAsyncState<JumboProps>(),
  Jumbo: emptyFragment
}

export type EventOverviewLayoutProps = Omit<EventOverviewState, 'jumboContent' | 'filterOptions'> & {
  eventsOverviewClassNames: EventsOverviewClassNames
  filterOptions: GroupedOverviewFilterOptions
  filterUpdaters: FilterUpdaters
  jumboProps: JumboProps
}

export type EventsOverviewClassNames = {
  filterCheckbox: string,
  filterCheckboxInput: string,
  filterCheckboxLabel: string
  timelineButton: string
  jumboSize: 'large' | 'small'
}


export const initialGroupedOverviewResult: GroupedOverviewResult = {
  Result: [],
  NextPage: emptyFilters,
  PreviousPage: emptyFilters
}